"use client";

import React from "react";
import { MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const serviceCities = ["Aurora", "Batavia", "Chicago", "Elgin", "Geneva", "Naperville", "Oswego", "St. Charles", "Yorkville"];
const mapMarkers = [{
  top: "25%",
  left: "35%"
}, {
  top: "45%",
  left: "55%"
}, {
  top: "60%",
  left: "40%"
}, {
  top: "35%",
  left: "70%"
}, {
  top: "75%",
  left: "65%"
}, {
  top: "50%",
  left: "25%"
}];
export default function OurServiceArea() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: mapRef,
    isVisible: isMapVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: listRef,
    isVisible: isListVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-service-area" className="py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        
        {}
        <div ref={headerRef} className={`text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-sans text-3xl md:text-4xl font-bold text-primary mb-4 tracking-tight">
            Our Service Area
          </h2>
          <p className="font-['Helvetica','Arial',sans-serif] text-foreground max-w-2xl mx-auto text-lg">
            Providing revenue-driven digital marketing solutions to businesses across the region.
          </p>
        </div>

        {}
        <div ref={mapRef} className={`relative w-full h-[400px] md:h-[500px] mb-16 border border-border bg-muted overflow-hidden transition-all duration-1000 ease-out ${isMapVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
          {}
          <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586456/img/service_area_map_desaturated.png)] bg-cover bg-center grayscale opacity-60" aria-hidden="true" />
          
          {}
          {mapMarkers.map((marker, i) => <div key={i} data-index={i} className="absolute transform -translate-x-1/2 -translate-y-1/2" style={{
          top: marker.top,
          left: marker.left
        }}>
              <div className="relative">
                <MapPin className="w-8 h-8 text-secondary drop-shadow-md" weight="fill" />
                <div className="absolute top-1/2 left-1/2 w-3 h-3 bg-secondary rounded-full transform -translate-x-1/2 -translate-y-1/2 animate-ping opacity-75" />
              </div>
            </div>)}
        </div>

        {}
        <div ref={listRef} className={`transition-all duration-700 delay-300 ease-out ${isListVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h3 className="font-sans text-xl font-semibold text-primary mb-8 text-center md:text-left border-b border-border pb-4">
            Key Cities We Serve
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-4 gap-x-8">
            {serviceCities.map((city, i) => <div key={i} data-index={i} className="flex items-center space-x-2 group">
                <div className="w-1.5 h-1.5 bg-secondary rounded-none transition-transform group-hover:scale-150" />
                <span className="font-['Helvetica','Arial',sans-serif] text-foreground text-base">
                  {city}
                </span>
              </div>)}
          </div>
        </div>

      </div>
    </section>;
}